import {videoSvg as Icon__small__videoSvg} from '../Icon__small/Icon__small--video.js';

export var video = {
  name: 'video',
  category: 'icon',
  colorable: true,
  svg: Icon__small__videoSvg,
};
